import type { TaskPlatform } from '../types/tasks.types';

export const TASK_PLATFORM_LABELS: Record<TaskPlatform, string> = {
  asana: 'Asana',
  clickup: 'ClickUp',
};

export const TASK_LOOKUP_MESSAGES = {
  SEARCH_FAILED: 'Failed to search tasks',
  SEARCH_UNAVAILABLE: 'Search is unavailable right now — use the task ID below.',
  INVALID_TASK: 'Invalid task data received',
} as const;
